import Vue from "vue";

Vue.component("wto-language-dropdown-list", {
	props: [
		"value",
	],
	data() {
		return {
			typedValue: '',
			wtoLanguages: []
		}
	},
	methods: {
		selected: function (option) {
			if (option) {
				this.$emit("update:value", option.id);
			} else {
				this.$emit("update:value", null);
			}
		}
	},
	computed: {
		filteredLanguages() {
			return this.wtoLanguages.filter(language =>
				language.text
					.toString()
					.toLowerCase()
					.indexOf(this.typedValue.toLowerCase()) >= 0
			);
		}
	},
	mounted() {
		const self = this;
		this.wtoLanguages = window.enums.wtoLanguages;
		if (this.value) {
			this.typedValue = (this.wtoLanguages.filter(language => language.id == this.value)[0]).text;
		}
	},
	template: `
      <div>
        <b-autocomplete
            v-model="typedValue"
            field="text"
            @select="selected"
            :open-on-focus="true"
            :data="filteredLanguages"
            :clearable="true"
        >
        </b-autocomplete>
      </div>
	`
});